<div class="modal-header"></div>

<div class="modal-body" [innerHTML]="text | translate"></div>

<div class="modal-footer">
    <button type="button" class="btn btn-default" #okBtn (click)="onOkClick()">
        {{getBtnText() | translate}}
    </button>
</div>
